var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPocketCloset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "380px",
    height: "380px",
    viewBox: "0 0 380 380",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.2455 0.6609 0.92 0.6609 0.92 2.4109 0.2455 2.4109"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.5481 0.0711 1.8851 0.0711 1.8851 1 0.5481 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.0492 0.617 1.4012 0.617 1.4012 1.5484 0.0492 1.5484"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 0.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-582",
    transform: "translate(37.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 242.308,
    y1: 76.1069,
    x2: 242.308,
    y2: 82.4529,
    id: "Stroke-1",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-581",
    transform: "translate(0.000000, 0.383000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(303.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.7455,
    y1: 2.4109,
    x2: 0.7455,
    y2: 0.6609,
    id: "Stroke-2",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.2948,177.8318 C71.2798,177.8208 71.2648,177.8078 71.2528,177.7918",
    id: "Stroke-5",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1405,175.6755 C72.1325,175.6695 72.1255,175.6645 72.1175,175.6595 C72.1085,175.6545 72.0995,175.6495 72.0905,175.6445 C72.0735,175.6355 72.0555,175.6275 72.0365,175.6215 C72.0005,175.6095 71.9615,175.6015 71.9225,175.5985 C71.9125,175.5975 71.9025,175.5975 71.8925,175.5975 L71.8785,175.5975 C71.8735,175.5975 71.8695,175.5985 71.8645,175.5985 C71.8545,175.5995 71.8445,175.6015 71.8345,175.6025 C71.8255,175.6045 71.8155,175.6075 71.8075,175.6105 C71.7975,175.6135 71.7875,175.6165 71.7785,175.6205 C71.7695,175.6255 71.7625,175.6305 71.7545,175.6355 L71.7435,175.6475 C71.7395,175.6505 71.7365,175.6545 71.7335,175.6575 C71.7285,175.6655 71.7245,175.6745 71.7225,175.6835",
    id: "Stroke-7",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7225,
    y1: 175.6833,
    x2: 71.5995,
    y2: 176.1863,
    id: "Stroke-9",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7123,
    y1: 177.825,
    x2: 71.7683,
    y2: 177.596,
    id: "Stroke-11",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2059,175.8015 C72.2089,175.7885 72.2089,175.7765 72.2059,175.7645 C72.2039,175.7515 72.1979,175.7395 72.1919,175.7305 C72.1849,175.7195 72.1769,175.7095 72.1679,175.7005 C72.1599,175.6915 72.1499,175.6835 72.1409,175.6755",
    id: "Stroke-13",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.1644,
    y1: 175.9714,
    x2: 72.2064,
    y2: 175.8014,
    id: "Stroke-15",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.8724,
    y1: 156.5417,
    x2: 259.8724,
    y2: 158.3107,
    id: "Stroke-17",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5057,166.0867 L110.7547,166.1897 C110.8387,166.2237 110.9217,166.2577 111.0047,166.2917",
    id: "Stroke-19",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.0043,166.2917 C111.0053,166.2917 111.0073,166.2917 111.0083,166.2907",
    id: "Stroke-21",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5218,168.3015 C109.5038,168.2935 109.4858,168.2845 109.4678,168.2745 C109.4608,168.2705 109.4548,168.2655 109.4488,168.2615",
    id: "Stroke-23",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8255,161.7449 C108.8285,161.7439 108.8315,161.7439 108.8345,161.7449",
    id: "Stroke-25",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.5472,
    y1: 164.7722,
    x2: 114.4212,
    y2: 171.5392,
    id: "Stroke-27",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5262,168.2986 C109.5272,168.2996 109.5282,168.2996 109.5292,168.3006 C109.5302,168.3006 109.5322,168.3016 109.5332,168.3016",
    id: "Stroke-29",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.0106,166.2917 L111.0096,166.2917 C111.0096,166.2917 111.0086,166.2917 111.0086,166.2907",
    id: "Stroke-31",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5111,169.8982 C108.4791,169.8832 108.4481,169.8662 108.4171,169.8442 C108.3861,169.8232 108.3561,169.7972 108.3271,169.7692 C108.2981,169.7412 108.2701,169.7092 108.2441,169.6752 C108.2311,169.6582 108.2191,169.6402 108.2061,169.6222 C108.1941,169.6032 108.1821,169.5852 108.1711,169.5652 C108.1491,169.5262 108.1291,169.4862 108.1121,169.4442 C108.1031,169.4222 108.0951,169.4012 108.0881,169.3792 C108.0801,169.3582 108.0741,169.3362 108.0681,169.3152 C108.0551,169.2712 108.0461,169.2282 108.0401,169.1842 C108.0341,169.1402 108.0311,169.0972 108.0301,169.0552",
    id: "Stroke-33",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8255,161.7449 C108.7825,161.7269 108.7355,161.7159 108.6875,161.7129 C108.6405,161.7099 108.5935,161.7159 108.5485,161.7329",
    id: "Stroke-35",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.4281,
    y1: 171.5457,
    x2: 114.5541,
    y2: 164.7797,
    id: "Stroke-37",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.9886,
    y1: 172.0779,
    x2: 113.9886,
    y2: 172.0779,
    id: "Stroke-39",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5248,169.9138 C108.5218,169.9128 108.5188,169.9098 108.5168,169.9068 C108.5138,169.9048 108.5118,169.9008 108.5108,169.8978",
    id: "Stroke-41",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.0267,169.0476 C108.0267,169.0506 108.0277,169.0536 108.0297,169.0556",
    id: "Stroke-43",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.3915,
    y1: 161.8123,
    x2: 108.3915,
    y2: 161.8123,
    id: "Stroke-45",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.159,172.033 C114.167,172.029 114.175,172.026 114.183,172.022 C114.185,172.021 114.186,172.02 114.188,172.019 C114.195,172.016 114.201,172.013 114.207,172.01 C114.226,171.999 114.245,171.985 114.262,171.971 C114.276,171.959 114.288,171.946 114.301,171.931 C114.313,171.918 114.324,171.903 114.335,171.887 C114.355,171.856 114.372,171.821 114.387,171.783 C114.4,171.747 114.41,171.708 114.417,171.667 C114.424,171.628 114.428,171.588 114.428,171.546",
    id: "Stroke-47",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5487,161.7332 C108.5447,161.7342 108.5397,161.7362 108.5347,161.7382 C108.5277,161.7422 108.5207,161.7452 108.5137,161.7492",
    id: "Stroke-49",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.1219,172.0437 C114.1349,172.0407 114.1469,172.0367 114.1589,172.0327",
    id: "Stroke-51",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.9886,172.0779 C114.0326,172.0659 114.0776,172.0559 114.1216,172.0439",
    id: "Stroke-53",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 99.6482,
    x2: 91.7856,
    y2: 99.1412,
    id: "Stroke-55",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.5477,
    y1: 304.825,
    x2: 90.4487,
    y2: 288.85,
    id: "Stroke-57",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-61",
    transform: "translate(132.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-60"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.8851,
    y1: 0.3171,
    x2: 0.5481,
    y2: 0.8251,
    id: "Stroke-59",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 108.5135,
    y1: 161.7488,
    x2: 108.3915,
    y2: 161.8118,
    id: "Stroke-62",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.7342,172.0554 C113.7522,172.0624 113.7702,172.0684 113.7882,172.0734 C113.8062,172.0774 113.8242,172.0814 113.8412,172.0844 C113.8592,172.0874 113.8782,172.0884 113.8952,172.0884 C113.9122,172.0884 113.9302,172.0874 113.9472,172.0854 C113.9612,172.0834 113.9752,172.0804 113.9882,172.0774",
    id: "Stroke-64",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5248,169.9138 L108.5458,169.9228 C108.5488,169.9238 108.5518,169.9258 108.5558,169.9268 C108.5568,169.9278 108.5588,169.9278 108.5608,169.9288 C108.5618,169.9298 108.5638,169.9308 108.5658,169.9308 C108.5788,169.9358 108.5928,169.9418 108.6068,169.9468 C108.6328,169.9588 108.6608,169.9698 108.6878,169.9808 C108.7418,170.0038 108.7958,170.0258 108.8508,170.0478 C108.9588,170.0928 109.0678,170.1378 109.1758,170.1828 C109.3928,170.2708 109.6098,170.3598 109.8278,170.4498 C110.2608,170.6278 110.6948,170.8068 111.1288,170.9848 C111.5638,171.1638 111.9978,171.3418 112.4318,171.5198 C112.6488,171.6088 112.8658,171.6988 113.0828,171.7878 C113.1918,171.8328 113.2998,171.8768 113.4078,171.9218 C113.4628,171.9438 113.5168,171.9668 113.5708,171.9888 C113.5978,171.9998 113.6258,172.0108 113.6518,172.0218 C113.6658,172.0278 113.6798,172.0328 113.6928,172.0388 C113.6948,172.0398 113.6968,172.0408 113.6978,172.0408 C113.6998,172.0418 113.7018,172.0418 113.7028,172.0428 C113.7068,172.0448 113.7098,172.0458 113.7128,172.0478 C113.7208,172.0508 113.7278,172.0528 113.7338,172.0558",
    id: "Stroke-66",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-70",
    transform: "translate(171.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-69"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.0492,
    y1: 1.3049,
    x2: 1.4012,
    y2: 0.7919,
    id: "Stroke-68",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 197.7445,
    y1: 10.4089,
    x2: 172.4015,
    y2: 0.7919,
    id: "Stroke-71",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.3929,
    y1: 10.9216,
    x2: 197.7449,
    y2: 10.4086,
    id: "Stroke-73",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.1185,
    y1: 105.3479,
    x2: 216.1185,
    y2: 85.6729,
    id: "Stroke-75",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.3939,
    y1: 158.8562,
    x2: 259.3939,
    y2: 193.7672,
    id: "Stroke-77",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.9276,
    y1: 155.7136,
    x2: 68.9276,
    y2: 157.4636,
    id: "Stroke-79",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.1752,
    y1: 254.5759,
    x2: 1.1752,
    y2: 65.7639,
    id: "Stroke-81",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.1752,
    y1: 65.7644,
    x2: 2.5272,
    y2: 65.2514,
    id: "Stroke-84",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.5189,
    y1: 264.1931,
    x2: 1.1749,
    y2: 254.5761,
    id: "Stroke-86",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.8705,
    y1: 263.6804,
    x2: 26.5185,
    y2: 264.1934,
    id: "Stroke-88",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.8705,
    y1: 74.8684,
    x2: 26.5185,
    y2: 75.3814,
    id: "Stroke-90",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3168,170.9939 C89.3018,170.9819 89.2878,170.9689 89.2748,170.9529",
    id: "Stroke-92",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1625,168.8367 C90.1555,168.8307 90.1475,168.8257 90.1395,168.8207 C90.1315,168.8157 90.1215,168.8107 90.1135,168.8067 C90.0955,168.7967 90.0775,168.7897 90.0595,168.7827 C90.0225,168.7707 89.9835,168.7627 89.9455,168.7597 C89.9345,168.7587 89.9255,168.7587 89.9145,168.7587 L89.9005,168.7587 C89.8955,168.7597 89.8915,168.7597 89.8865,168.7607 C89.8765,168.7607 89.8665,168.7627 89.8565,168.7647 C89.8475,168.7667 89.8385,168.7687 89.8295,168.7717 C89.8195,168.7747 89.8095,168.7777 89.8005,168.7827 C89.7925,168.7867 89.7845,168.7917 89.7775,168.7977 C89.7725,168.8007 89.7685,168.8047 89.7655,168.8087 C89.7625,168.8117 89.7585,168.8157 89.7565,168.8197 C89.7505,168.8267 89.7465,168.8357 89.7455,168.8447",
    id: "Stroke-94",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.745,
    y1: 168.8445,
    x2: 89.622,
    y2: 169.3475,
    id: "Stroke-96",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.7347,
    y1: 170.9861,
    x2: 89.7907,
    y2: 170.7571,
    id: "Stroke-98",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2284,168.9626 C90.2314,168.9496 90.2314,168.9386 90.2284,168.9256 C90.2254,168.9136 90.2204,168.9016 90.2134,168.8916 C90.2074,168.8806 90.1994,168.8706 90.1904,168.8616 C90.1824,168.8526 90.1724,168.8446 90.1624,168.8366",
    id: "Stroke-100",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3168,194.575 C89.3018,194.563 89.2878,194.55 89.2748,194.534",
    id: "Stroke-102",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1625,192.4177 C90.1555,192.4117 90.1475,192.4067 90.1395,192.4017 C90.1315,192.3967 90.1215,192.3917 90.1135,192.3877 C90.0955,192.3787 90.0775,192.3707 90.0595,192.3637 C90.0225,192.3517 89.9835,192.3437 89.9455,192.3407 C89.9345,192.3407 89.9255,192.3397 89.9145,192.3397 C89.9105,192.3397 89.9055,192.3407 89.9005,192.3407 C89.8955,192.3407 89.8915,192.3407 89.8865,192.3417 C89.8765,192.3417 89.8665,192.3437 89.8565,192.3457 C89.8475,192.3477 89.8385,192.3497 89.8295,192.3527 C89.8195,192.3557 89.8095,192.3587 89.8005,192.3637 C89.7925,192.3677 89.7845,192.3727 89.7775,192.3787 C89.7725,192.3817 89.7685,192.3857 89.7655,192.3897 C89.7625,192.3927 89.7585,192.3967 89.7565,192.4007 C89.7505,192.4087 89.7465,192.4167 89.7455,192.4257",
    id: "Stroke-104",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.745,
    y1: 192.4255,
    x2: 89.622,
    y2: 192.9285,
    id: "Stroke-106",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.7347,
    y1: 194.5671,
    x2: 89.7907,
    y2: 194.3381,
    id: "Stroke-108",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2284,192.5437 C90.2314,192.5307 90.2314,192.5197 90.2284,192.5067 C90.2254,192.4947 90.2204,192.4827 90.2134,192.4727 C90.2074,192.4617 90.1994,192.4517 90.1904,192.4427 C90.1824,192.4347 90.1724,192.4257 90.1624,192.4177",
    id: "Stroke-110",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.1185,
    y1: 252.6462,
    x2: 199.8435,
    y2: 246.4692,
    id: "Stroke-112",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.4564,
    y1: 252.1384,
    x2: 216.1184,
    y2: 252.6464,
    id: "Stroke-114",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.3929,
    y1: 10.9216,
    x2: 196.3929,
    y2: 12.6716,
    id: "Stroke-116",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.0492,
    y1: 1.3049,
    x2: 196.3932,
    y2: 10.9219,
    id: "Stroke-118",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5267,
    y1: 65.2517,
    x2: 171.0487,
    y2: 1.3047,
    id: "Stroke-120",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.2806,
    y1: 255.9763,
    x2: 174.9846,
    y2: 288.7223,
    id: "Stroke-122",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.3929,
    y1: 12.6716,
    x2: 196.3929,
    y2: 59.4466,
    id: "Stroke-124",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.3797,
    y1: 37.7209,
    x2: 130.3797,
    y2: 43.8879,
    id: "Stroke-126",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.2777,
    y1: 149.8645,
    x2: 259.8727,
    y2: 156.5415,
    id: "Stroke-128",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.8094,
    y1: 21.6208,
    x2: 172.8094,
    y2: 68.3958,
    id: "Stroke-130",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.308,
    y1: 97.179,
    x2: 242.308,
    y2: 149.853,
    id: "Stroke-132",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.7445,
    y1: 58.9338,
    x2: 197.7445,
    y2: 10.4088,
    id: "Stroke-134",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.8431,
    y1: 91.8376,
    x2: 199.8431,
    y2: 99.1406,
    id: "Stroke-136",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.9281,
    y1: 75.5603,
    x2: 153.9281,
    y2: 28.7853,
    id: "Stroke-138",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.266,
    y1: 75.053,
    x2: 155.266,
    y2: 28.278,
    id: "Stroke-140",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.9135,
    y1: 158.6736,
    x2: 259.3935,
    y2: 158.8566,
    id: "Stroke-142",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.1869,
    y1: 169.1326,
    x2: 90.2289,
    y2: 168.9626,
    id: "Stroke-144",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.8441,
    y1: 159.1365,
    x2: 217.8441,
    y2: 159.1365,
    id: "Stroke-146",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9144,
    y1: 221.2478,
    x2: 70.3354,
    y2: 227.9178,
    id: "Stroke-148",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.8861,
    y1: 88.74,
    x2: 176.3501,
    y2: 120.439,
    id: "Stroke-150",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.8724,
    y1: 156.5417,
    x2: 176.3504,
    y2: 188.2337,
    id: "Stroke-152",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.1185,
    y1: 105.3171,
    x2: 199.8435,
    y2: 99.1411,
    id: "Stroke-154",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.4564,
    y1: 104.8406,
    x2: 217.4564,
    y2: 85.1536,
    id: "Stroke-156",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.5052,
    y1: 190.3083,
    x2: 259.3942,
    y2: 158.8563,
    id: "Stroke-158",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.4501,
    y1: 67.4417,
    x2: 152.8871,
    y2: 75.9557,
    id: "Stroke-160",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.5189,
    y1: 75.3816,
    x2: 26.5189,
    y2: 264.1936,
    id: "Stroke-162",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.1752,
    y1: 65.7644,
    x2: 26.5192,
    y2: 75.3814,
    id: "Stroke-164",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.8705,
    y1: 74.8684,
    x2: 2.5265,
    y2: 65.2514,
    id: "Stroke-166",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.8431,
    y1: 246.4695,
    x2: 199.8431,
    y2: 240.0255,
    id: "Stroke-168",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.2806,
    y1: 236.5408,
    x2: 261.2806,
    y2: 68.5248,
    id: "Stroke-170",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.9427,
    y1: 237.0476,
    x2: 261.2807,
    y2: 236.5406,
    id: "Stroke-172",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.9427,
    y1: 69.032,
    x2: 259.9427,
    y2: 237.048,
    id: "Stroke-174",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.4496,
    y1: 237.3884,
    x2: 68.9976,
    y2: 246.3244,
    id: "Stroke-176",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.9979,
    y1: 246.324,
    x2: 70.3359,
    y2: 245.816,
    id: "Stroke-178",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.0126,
    y1: 269.2751,
    x2: 174.9986,
    y2: 269.2701,
    id: "Stroke-180",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.35,
    y1: 268.7673,
    x2: 175.013,
    y2: 269.2753,
    id: "Stroke-182",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9276,241.0593 C87.9076,241.0403 87.8896,241.0203 87.8746,240.9973 C87.8596,240.9753 87.8476,240.9513 87.8416,240.9233",
    id: "Stroke-184",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0433,241.5945 C88.0203,241.5735 87.9993,241.5485 87.9843,241.5205 C87.9693,241.4925 87.9603,241.4615 87.9603,241.4295",
    id: "Stroke-186",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8856,240.1765 C89.8706,240.1725 89.8566,240.1685 89.8426,240.1645",
    id: "Stroke-188",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8856,240.1765 C89.9686,240.1975 90.0526,240.2265 90.1316,240.2605 C90.1716,240.2785 90.2106,240.2985 90.2476,240.3215 C90.2836,240.3435 90.3206,240.3695 90.3516,240.3995",
    id: "Stroke-190",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3192,241.4294 C90.3192,241.4504 90.3162,241.4694 90.3092,241.4894 C90.3052,241.4994 90.3002,241.5094 90.2952,241.5194 C90.2892,241.5304 90.2832,241.5394 90.2762,241.5494 C90.2682,241.5604 90.2592,241.5704 90.2512,241.5794 C90.2402,241.5904 90.2302,241.6004 90.2192,241.6104 C90.2072,241.6194 90.1942,241.6294 90.1822,241.6394 C90.1682,241.6494 90.1532,241.6584 90.1382,241.6674 C90.1192,241.6794 90.0982,241.6914 90.0772,241.7004 C90.0552,241.7114 90.0322,241.7224 90.0082,241.7324 C89.9842,241.7424 89.9582,241.7514 89.9332,241.7604 C89.9062,241.7704 89.8782,241.7794 89.8512,241.7864 C89.8022,241.8004 89.7522,241.8134 89.7022,241.8234 C89.6502,241.8334 89.5982,241.8424 89.5452,241.8504 C89.4432,241.8644 89.3382,241.8724 89.2352,241.8754 C89.1832,241.8774 89.1322,241.8774 89.0802,241.8764 C89.0272,241.8754 88.9752,241.8734 88.9232,241.8694 C88.8702,241.8664 88.8182,241.8614 88.7652,241.8544 C88.7142,241.8474 88.6642,241.8394 88.6132,241.8294 C88.5862,241.8254 88.5582,241.8194 88.5312,241.8134 C88.5052,241.8074 88.4792,241.8004 88.4532,241.7934 C88.4292,241.7864 88.4042,241.7804 88.3802,241.7724 C88.3572,241.7654 88.3352,241.7574 88.3122,241.7484 C88.2972,241.7424 88.2822,241.7374 88.2682,241.7314 C88.2542,241.7254 88.2402,241.7194 88.2262,241.7134 C88.2142,241.7064 88.2012,241.7004 88.1882,241.6944 C88.1762,241.6884 88.1652,241.6824 88.1532,241.6754 C88.1422,241.6684 88.1312,241.6624 88.1212,241.6564 C88.1112,241.6494 88.1012,241.6424 88.0922,241.6354 C88.0832,241.6284 88.0742,241.6214 88.0662,241.6154 C88.0582,241.6094 88.0502,241.6024 88.0432,241.5944",
    id: "Stroke-192",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4437,
    y1: 240.8767,
    x2: 90.4437,
    y2: 240.5817,
    id: "Stroke-194",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4437,240.5818 C90.4437,240.5468 90.4337,240.5128 90.4167,240.4808 C90.3997,240.4508 90.3767,240.4238 90.3517,240.3988",
    id: "Stroke-196",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9598,
    y1: 241.0876,
    x2: 87.9598,
    y2: 241.4296,
    id: "Stroke-198",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3246,262.7195 C34.3226,262.7295 34.3186,262.7385 34.3146,262.7475 C34.3106,262.7575 34.3056,262.7665 34.2996,262.7765 C34.2936,262.7855 34.2866,262.7955 34.2796,262.8045 C34.2716,262.8155 34.2626,262.8235 34.2536,262.8335 C34.2436,262.8435 34.2336,262.8525 34.2226,262.8625 C34.2106,262.8715 34.1986,262.8805 34.1856,262.8895 C34.1716,262.8995 34.1576,262.9075 34.1426,262.9165 C34.1266,262.9265 34.1106,262.9355 34.0946,262.9435 C34.0726,262.9545 34.0506,262.9645 34.0276,262.9745 C34.0026,262.9855 33.9776,262.9945 33.9526,263.0025 C33.9256,263.0125 33.8986,263.0215 33.8706,263.0295 C33.8426,263.0375 33.8126,263.0455 33.7836,263.0525 C33.7316,263.0655 33.6776,263.0755 33.6246,263.0845 C33.5696,263.0945 33.5136,263.1015 33.4576,263.1075 C33.4026,263.1135 33.3466,263.1165 33.2906,263.1185 C33.2366,263.1215 33.1826,263.1225 33.1286,263.1225 C33.1216,263.1225 33.1146,263.1215 33.1076,263.1215 L33.0876,263.1215 C33.0746,263.1215 33.0606,263.1205 33.0476,263.1205 C33.0196,263.1195 32.9926,263.1185 32.9656,263.1165 C32.9096,263.1145 32.8536,263.1095 32.7986,263.1025 C32.7426,263.0955 32.6876,263.0875 32.6326,263.0765 C32.5796,263.0675 32.5266,263.0555 32.4746,263.0415 C32.4446,263.0335 32.4156,263.0255 32.3876,263.0165 C32.3596,263.0075 32.3326,262.9975 32.3056,262.9875 C32.2816,262.9775 32.2566,262.9675 32.2326,262.9555 C32.2106,262.9465 32.1886,262.9345 32.1676,262.9225 C32.1516,262.9125 32.1356,262.9035 32.1196,262.8925 C32.1056,262.8835 32.0926,262.8725 32.0796,262.8625 C32.0676,262.8525 32.0556,262.8425 32.0446,262.8305 C32.0346,262.8215 32.0256,262.8105 32.0176,262.7995 C32.0096,262.7895 32.0026,262.7795 31.9966,262.7675 C31.9916,262.7575 31.9866,262.7465 31.9816,262.7365 C31.9786,262.7265 31.9756,262.7155 31.9736,262.7055 C31.9716,262.6955 31.9706,262.6855 31.9706,262.6745",
    id: "Stroke-200",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8963,261.4216 C33.8823,261.4176 33.8673,261.4136 33.8533,261.4096",
    id: "Stroke-202",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8963,261.4216 C33.9593,261.4386 34.0223,261.4576 34.0823,261.4816 C34.1423,261.5046 34.2033,261.5326 34.2583,261.5666 C34.2723,261.5746 34.2863,261.5836 34.3003,261.5936 C34.3133,261.6036 34.3263,261.6126 34.3373,261.6226 C34.3513,261.6336 34.3633,261.6456 34.3753,261.6566 C34.3863,261.6686 34.3963,261.6806 34.4053,261.6926 C34.4163,261.7066 34.4253,261.7216 34.4323,261.7356 C34.4393,261.7506 34.4443,261.7646 34.4483,261.7796 C34.4573,261.8126 34.4573,261.8446 34.4483,261.8766",
    id: "Stroke-204",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4481,262.073 C34.4571,262.106 34.4571,262.138 34.4481,262.172",
    id: "Stroke-206",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3246,262.6306 C34.3326,262.6596 34.3326,262.6896 34.3246,262.7196",
    id: "Stroke-208",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.9711,
    y1: 262.3328,
    x2: 31.9711,
    y2: 262.6748,
    id: "Stroke-210",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.0023,
    y1: 166.3152,
    x2: 110.9893,
    y2: 166.3172,
    id: "Stroke-212",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.0213,166.324 C111.0203,166.323 111.0183,166.322 111.0163,166.322 C111.0143,166.32 111.0113,166.319 111.0093,166.318 C111.0083,166.318 111.0073,166.317 111.0053,166.317 C111.0053,166.316 111.0043,166.316 111.0043,166.316 C111.0033,166.316 111.0033,166.316 111.0033,166.315 L111.0023,166.315 L111.0023,166.315",
    id: "Stroke-214",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1932,168.6296 C111.1932,168.6326 111.1932,168.6346 111.1932,168.6376",
    id: "Stroke-216",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5018,168.2859 C109.5008,168.2849 109.5008,168.2849 109.4998,168.2849",
    id: "Stroke-218",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4994,168.2849 C109.5004,168.2849 109.5004,168.2849 109.5014,168.2859",
    id: "Stroke-220",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5018,168.2859 L109.5238,168.2949 C109.5258,168.2959 109.5268,168.2969 109.5288,168.2969",
    id: "Stroke-222",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.118,168.864 C111.121,168.862 111.125,168.859 111.128,168.857",
    id: "Stroke-224",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.118,168.864 C111.116,168.866 111.113,168.867 111.111,168.869",
    id: "Stroke-226",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1283,168.8572 C111.1413,168.8482 111.1533,168.8362 111.1653,168.8242 C111.1773,168.8092 111.1883,168.7932 111.1963,168.7732 C111.2053,168.7542 111.2123,168.7342 111.2173,168.7112 C111.2223,168.6902 111.2253,168.6662 111.2263,168.6412 C111.2273,168.6292 111.2273,168.6172 111.2273,168.6042 C111.2273,168.5912 111.2283,168.5802 111.2283,168.5672 C111.2283,168.5422 111.2293,168.5172 111.2293,168.4932 L111.2323,168.3432 C111.2343,168.2442 111.2353,168.1452 111.2373,168.0452 C111.2413,167.8472 111.2453,167.6482 111.2493,167.4502 C111.2533,167.2512 111.2563,167.0522 111.2603,166.8532 C111.2603,166.8292 111.2603,166.8042 111.2613,166.7792 C111.2613,166.7672 111.2613,166.7542 111.2613,166.7422 C111.2603,166.7292 111.2593,166.7162 111.2573,166.7032 C111.2543,166.6762 111.2493,166.6502 111.2423,166.6242 C111.2353,166.5982 111.2263,166.5722 111.2153,166.5462 C111.2043,166.5222 111.1913,166.4982 111.1773,166.4752 C111.1633,166.4532 111.1473,166.4312 111.1303,166.4122 C111.1143,166.3932 111.0963,166.3762 111.0783,166.3612 C111.0593,166.3462 111.0413,166.3342 111.0213,166.3242",
    id: "Stroke-228",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.9291,168.8728 C110.9251,168.8708 110.9221,168.8698 110.9181,168.8678",
    id: "Stroke-230",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.0785,
    y1: 168.8689,
    x2: 111.0785,
    y2: 168.8689,
    id: "Stroke-232",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2162,168.6511 C111.2162,168.6531 111.2162,168.6551 111.2162,168.6571 C111.2152,168.6641 111.2152,168.6701 111.2142,168.6751 C111.2142,168.6781 111.2142,168.6801 111.2132,168.6821",
    id: "Stroke-234",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2167,168.614 L111.2167,168.62 L111.2167,168.629 L111.2167,168.634 C111.2167,168.635 111.2167,168.636 111.2167,168.637 L111.2167,168.642 L111.2167,168.647",
    id: "Stroke-236",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2508,166.7751 L111.2508,166.7791 L111.2508,166.7841 L111.2508,166.7891 C111.2508,166.7951 111.2508,166.8011 111.2508,166.8081 L111.2508,166.8131",
    id: "Stroke-238",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.9154,168.8669 L110.9154,168.8669 C110.9164,168.8669 110.9164,168.8679 110.9174,168.8679",
    id: "Stroke-240",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.2274,
    y1: 166.7888,
    x2: 111.2274,
    y2: 166.7978,
    id: "Stroke-242",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.9818,168.8855 C110.9788,168.8845 110.9748,168.8845 110.9718,168.8835 C110.9628,168.8825 110.9538,168.8805 110.9448,168.8775 C110.9418,168.8765 110.9388,168.8755 110.9358,168.8745",
    id: "Stroke-244",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1942,168.572 C111.1942,168.552 111.1952,168.534 111.1952,168.514 C111.1962,168.476 111.1962,168.438 111.1972,168.399 C111.1982,168.323 111.2002,168.246 111.2012,168.17",
    id: "Stroke-246",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1942,168.572 C111.1942,168.582 111.1942,168.592 111.1942,168.6",
    id: "Stroke-248",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.8578,
    y1: 52.7429,
    x2: 153.8578,
    y2: 54.4929,
    id: "Stroke-250",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.4501,
    y1: 43.8606,
    x2: 153.8581,
    y2: 52.7426,
    id: "Stroke-252",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1932,168.6296 L111.1932,168.6146 C111.1932,168.6126 111.1932,168.6096 111.1932,168.6086 L111.1932,168.6006",
    id: "Stroke-254",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.308,
    y1: 230.3562,
    x2: 217.456,
    y2: 239.7862,
    id: "Stroke-256",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.202,168.1638 C111.204,168.0128 111.207,167.8608 111.21,167.7098 C111.213,167.5568 111.216,167.4028 111.219,167.2498 C111.22,167.1728 111.222,167.0968 111.223,167.0188 C111.224,166.9808 111.224,166.9418 111.225,166.9038 C111.225,166.8848 111.226,166.8658 111.226,166.8468 C111.226,166.8368 111.226,166.8278 111.227,166.8178 L111.227,166.8038 C111.227,166.8028 111.227,166.8008 111.227,166.7998 L111.227,166.7978",
    id: "Stroke-258",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.308,
    y1: 223.9119,
    x2: 242.308,
    y2: 230.3559,
    id: "Stroke-260",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.202,168.1638 L111.202,168.1638 C111.202,168.1658 111.202,168.1678 111.202,168.1698",
    id: "Stroke-262",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1625,145.2556 C90.1555,145.2506 90.1475,145.2446 90.1395,145.2396 C90.1315,145.2346 90.1215,145.2296 90.1135,145.2246 C90.0955,145.2156 90.0775,145.2086 90.0595,145.2016 C90.0225,145.1896 89.9835,145.1806 89.9455,145.1786 C89.9345,145.1776 89.9255,145.1776 89.9145,145.1776 C89.9105,145.1776 89.9055,145.1776 89.9005,145.1776 C89.8955,145.1776 89.8915,145.1786 89.8865,145.1786 C89.8765,145.1796 89.8665,145.1806 89.8565,145.1826 C89.8475,145.1846 89.8385,145.1876 89.8295,145.1896 C89.8195,145.1936 89.8095,145.1966 89.8005,145.2016 C89.7925,145.2056 89.7845,145.2106 89.7775,145.2156 C89.7725,145.2196 89.7685,145.2226 89.7655,145.2266 C89.7625,145.2306 89.7585,145.2346 89.7565,145.2386 C89.7505,145.2456 89.7465,145.2546 89.7455,145.2636",
    id: "Stroke-264",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.745,
    y1: 145.2634,
    x2: 89.622,
    y2: 145.7664,
    id: "Stroke-266",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.7347,
    y1: 147.4045,
    x2: 89.7907,
    y2: 147.1765,
    id: "Stroke-268",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2284,145.3816 C90.2314,145.3696 90.2314,145.3566 90.2284,145.3446 C90.2254,145.3326 90.2204,145.3206 90.2134,145.3096 C90.2074,145.2996 90.1994,145.2896 90.1904,145.2806 C90.1824,145.2716 90.1724,145.2636 90.1624,145.2556",
    id: "Stroke-270",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1405,152.0945 C72.1325,152.0885 72.1255,152.0835 72.1175,152.0785 C72.1085,152.0735 72.0995,152.0685 72.0905,152.0635 C72.0735,152.0545 72.0555,152.0475 72.0365,152.0405 C72.0005,152.0285 71.9615,152.0195 71.9225,152.0175 C71.9125,152.0165 71.9025,152.0165 71.8925,152.0165 L71.8785,152.0165 C71.8735,152.0165 71.8695,152.0175 71.8645,152.0175 C71.8545,152.0185 71.8445,152.0195 71.8345,152.0215 C71.8255,152.0235 71.8155,152.0255 71.8075,152.0285 C71.7975,152.0315 71.7875,152.0355 71.7785,152.0395 C71.7695,152.0445 71.7625,152.0495 71.7545,152.0545 C71.7505,152.0575 71.7465,152.0615 71.7435,152.0655 C71.7395,152.0695 71.7365,152.0735 71.7335,152.0765 C71.7285,152.0845 71.7245,152.0935 71.7225,152.1025",
    id: "Stroke-272",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7225,
    y1: 152.1023,
    x2: 71.5995,
    y2: 152.6043,
    id: "Stroke-274",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2059,152.2205 C72.2089,152.2075 72.2089,152.1955 72.2059,152.1825 C72.2039,152.1705 72.1979,152.1595 72.1919,152.1485 C72.1849,152.1375 72.1769,152.1285 72.1679,152.1195 C72.1599,152.1105 72.1499,152.1015 72.1409,152.0945",
    id: "Stroke-276",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2948,201.4138 C71.2798,201.4018 71.2648,201.3888 71.2528,201.3728",
    id: "Stroke-278",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1405,199.2566 C72.1325,199.2506 72.1255,199.2456 72.1175,199.2406 C72.1085,199.2356 72.0995,199.2306 72.0905,199.2256 C72.0735,199.2166 72.0555,199.2096 72.0365,199.2026 C72.0005,199.1906 71.9615,199.1826 71.9225,199.1796 C71.9125,199.1786 71.9025,199.1786 71.8925,199.1786 C71.8885,199.1786 71.8835,199.1786 71.8785,199.1796 L71.8645,199.1796 C71.8545,199.1806 71.8445,199.1826 71.8345,199.1846 C71.8255,199.1856 71.8155,199.1886 71.8075,199.1916 C71.7975,199.1946 71.7875,199.1976 71.7785,199.2016 C71.7695,199.2066 71.7625,199.2116 71.7545,199.2166 L71.7435,199.2286 C71.7395,199.2316 71.7365,199.2356 71.7335,199.2396 C71.7285,199.2466 71.7245,199.2556 71.7225,199.2646",
    id: "Stroke-280",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7225,
    y1: 199.2644,
    x2: 71.5995,
    y2: 199.7674,
    id: "Stroke-282",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2059,199.3826 C72.2089,199.3696 72.2089,199.3576 72.2059,199.3456 C72.2039,199.3326 72.1979,199.3216 72.1919,199.3116 C72.1849,199.3006 72.1769,199.2906 72.1679,199.2816 C72.1599,199.2726 72.1499,199.2646 72.1409,199.2566",
    id: "Stroke-284",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.1644,
    y1: 199.5535,
    x2: 72.2064,
    y2: 199.3825,
    id: "Stroke-286",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.1869,
    y1: 145.552,
    x2: 90.2289,
    y2: 145.382,
    id: "Stroke-288",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.1644,
    y1: 152.3904,
    x2: 72.2064,
    y2: 152.2204,
    id: "Stroke-290",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6796,147.4666 C89.6926,147.4606 89.7046,147.4516 89.7146,147.4416 C89.7236,147.4306 89.7316,147.4186 89.7346,147.4046",
    id: "Stroke-292",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7123,
    y1: 201.406,
    x2: 71.7683,
    y2: 201.177,
    id: "Stroke-294",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1937,168.6003 C111.1937,168.6103 111.1937,168.6203 111.1937,168.6293",
    id: "Stroke-296",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2948,201.4138 C71.3018,201.4188 71.3098,201.4248 71.3178,201.4298 C71.3258,201.4348 71.3358,201.4388 71.3438,201.4438 C71.3618,201.4528 71.3798,201.4608 71.3978,201.4678 C71.4348,201.4798 71.4738,201.4878 71.5128,201.4908 C71.5228,201.4908 71.5328,201.4918 71.5428,201.4918 C71.5518,201.4918 71.5618,201.4908 71.5708,201.4898 C71.5808,201.4888 71.5908,201.4878 71.6018,201.4858 C71.6098,201.4838 71.6198,201.4818 71.6278,201.4788 C71.6378,201.4758 71.6478,201.4728 71.6558,201.4688 C71.6648,201.4638 71.6728,201.4588 71.6798,201.4528 C71.6878,201.4468 71.6948,201.4398 71.7008,201.4318 C71.7058,201.4238 71.7108,201.4148 71.7118,201.4058",
    id: "Stroke-298",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7123,154.2429 C71.7103,154.2529 71.7063,154.2609 71.7013,154.2679 C71.6983,154.2719 71.6953,154.2759 71.6913,154.2799 C71.6883,154.2839 71.6843,154.2879 71.6803,154.2909 C71.6733,154.2969 71.6653,154.3019 71.6563,154.3049 C71.6473,154.3099 71.6383,154.3139 71.6283,154.3169 C71.6193,154.3199 71.6093,154.3219 71.6003,154.3239 C71.5903,154.3259 71.5813,154.3269 71.5703,154.3279 C71.5663,154.3279 71.5613,154.3289 71.5563,154.3289 L71.5423,154.3289 C71.5323,154.3299 71.5223,154.3289 71.5123,154.3279 C71.4743,154.3259 71.4343,154.3169 71.3983,154.3049 C71.3793,154.2989 71.3613,154.2909 71.3443,154.2819 L71.3173,154.2669 C71.3103,154.2629 71.3023,154.2569 71.2953,154.2509",
    id: "Stroke-300",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3168,170.9939 C89.3248,170.9989 89.3318,171.0049 89.3398,171.0099 C89.3488,171.0149 89.3578,171.0199 89.3668,171.0239 C89.3838,171.0329 89.4018,171.0409 89.4208,171.0479 C89.4568,171.0599 89.4958,171.0679 89.5348,171.0709 C89.5448,171.0709 89.5548,171.0719 89.5648,171.0719 C89.5738,171.0719 89.5838,171.0709 89.5928,171.0699 C89.6038,171.0689 89.6138,171.0679 89.6238,171.0659 C89.6328,171.0639 89.6418,171.0619 89.6498,171.0589 C89.6598,171.0559 89.6698,171.0529 89.6788,171.0489 C89.6868,171.0439 89.6948,171.0389 89.7028,171.0329 C89.7108,171.0269 89.7168,171.0199 89.7228,171.0119 C89.7288,171.0039 89.7328,170.9949 89.7348,170.9859",
    id: "Stroke-302",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.3192,
    y1: 241.4294,
    x2: 90.3192,
    y2: 241.0874,
    id: "Stroke-304",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.0008,166.322 C111.0208,166.331 111.0398,166.343 111.0588,166.357 C111.0728,166.368 111.0868,166.381 111.1008,166.394",
    id: "Stroke-306",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3168,147.4124 C89.3018,147.4004 89.2878,147.3874 89.2748,147.3714",
    id: "Stroke-308",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6796,147.4666 C89.6726,147.4696 89.6656,147.4726 89.6586,147.4756 C89.6506,147.4786 89.6426,147.4806 89.6346,147.4826 C89.6186,147.4866 89.6036,147.4886 89.5876,147.4896 C89.5836,147.4896 89.5796,147.4896 89.5756,147.4906 L89.5696,147.4906 L89.5646,147.4906 C89.5556,147.4906 89.5476,147.4906 89.5396,147.4896 C89.5236,147.4886 89.5076,147.4876 89.4926,147.4846 C89.4606,147.4796 89.4296,147.4706 89.4006,147.4586 C89.3856,147.4526 89.3706,147.4456 89.3576,147.4386 C89.3496,147.4346 89.3436,147.4306 89.3356,147.4256 C89.3296,147.4216 89.3236,147.4176 89.3166,147.4126",
    id: "Stroke-310",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2948,154.2507 C71.2798,154.2387 71.2648,154.2257 71.2528,154.2107",
    id: "Stroke-312",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7123,
    y1: 154.2429,
    x2: 71.7683,
    y2: 154.0149,
    id: "Stroke-314",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.287,165.8777 L109.287,165.8757 C109.294,165.8357 109.308,165.8007 109.328,165.7707 C109.337,165.7557 109.348,165.7427 109.36,165.7317 C109.373,165.7207 109.387,165.7107 109.401,165.7037 C109.415,165.6957 109.43,165.6907 109.446,165.6887 C109.45,165.6877 109.454,165.6877 109.457,165.6867",
    id: "Stroke-316",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.35,
    y1: 190.2498,
    x2: 176.505,
    y2: 190.3088,
    id: "Stroke-318",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.35,
    y1: 225.1609,
    x2: 176.505,
    y2: 225.2199,
    id: "Stroke-320",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6796,194.6287 C89.6726,194.6327 89.6656,194.6357 89.6586,194.6377 C89.6506,194.6407 89.6426,194.6437 89.6346,194.6457 C89.6186,194.6497 89.6036,194.6507 89.5876,194.6517 C89.5836,194.6517 89.5796,194.6517 89.5756,194.6527 L89.5696,194.6527 L89.5646,194.6527 C89.5556,194.6527 89.5476,194.6527 89.5396,194.6517 C89.5236,194.6507 89.5076,194.6497 89.4926,194.6477 C89.4606,194.6417 89.4296,194.6327 89.4006,194.6207 C89.3856,194.6147 89.3706,194.6077 89.3576,194.6007 C89.3496,194.5967 89.3436,194.5927 89.3356,194.5877 C89.3296,194.5837 89.3236,194.5797 89.3166,194.5747",
    id: "Stroke-322",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.9706,
    y1: 288.7166,
    x2: 174.9846,
    y2: 288.7226,
    id: "Stroke-324",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.3797,
    y1: 63.4021,
    x2: 130.3797,
    y2: 67.4681,
    id: "Stroke-326",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9144,
    y1: 60.0017,
    x2: 87.9144,
    y2: 53.8347,
    id: "Stroke-328",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9144,
    y1: 83.5833,
    x2: 87.9144,
    y2: 79.5173,
    id: "Stroke-330",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9144,
    y1: 104.1179,
    x2: 87.9144,
    y2: 103.0979,
    id: "Stroke-332",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9144,
    y1: 104.2087,
    x2: 87.9144,
    y2: 104.2087,
    id: "Stroke-334",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9144,
    y1: 107.1643,
    x2: 87.9144,
    y2: 104.2993,
    id: "Stroke-336",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.1869,
    y1: 192.7146,
    x2: 90.2289,
    y2: 192.5436,
    id: "Stroke-338",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.4496,
    y1: 237.3611,
    x2: 27.8706,
    y2: 244.0321,
    id: "Stroke-340",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.4496,
    y1: 69.9485,
    x2: 45.4496,
    y2: 146.8585,
    id: "Stroke-342",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8534,261.4109 C33.8684,261.4139 33.8824,261.4179 33.8964,261.4219",
    id: "Stroke-344",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.308,
    y1: 200.2507,
    x2: 242.308,
    y2: 208.7927,
    id: "Stroke-346",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.8431,
    y1: 246.4695,
    x2: 176.3501,
    y2: 255.3845,
    id: "Stroke-348",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.9706,
    y1: 288.7166,
    x2: 133.8856,
    y2: 304.3066,
    id: "Stroke-350",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6796,194.6287 C89.6926,194.6227 89.7046,194.6137 89.7146,194.6047 C89.7236,194.5937 89.7316,194.5807 89.7346,194.5667",
    id: "Stroke-352",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6571,177.8865 C71.6701,177.8795 71.6821,177.8715 71.6921,177.8615 C71.7011,177.8505 71.7091,177.8385 71.7121,177.8245",
    id: "Stroke-354",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.7455,
    y1: 239.8523,
    x2: 261.2805,
    y2: 255.9653,
    id: "Stroke-356",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.7455,
    y1: 52.4109,
    x2: 303.7455,
    y2: 239.8519,
    id: "Stroke-358",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.8006,
    y1: 44.3914,
    x2: 112.8006,
    y2: 91.1664,
    id: "Stroke-361",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.4632,
    y1: 44.8992,
    x2: 111.4632,
    y2: 91.6742,
    id: "Stroke-363",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9144,
    y1: 221.2742,
    x2: 87.9144,
    y2: 198.0452,
    id: "Stroke-365",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 222.2361,
    x2: 87.9146,
    y2: 221.2741,
    id: "Stroke-367",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.7455,
    y1: 50.6609,
    x2: 133.8855,
    y2: 115.1159,
    id: "Stroke-369",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.8851,
    y1: 116.8655,
    x2: 303.7451,
    y2: 52.4105,
    id: "Stroke-371",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.3216,
    y1: 108.0559,
    x2: 199.8426,
    y2: 99.1409,
    id: "Stroke-373",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.8861,
    y1: 88.7297,
    x2: 242.3361,
    y2: 82.0697,
    id: "Stroke-375",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.4564,
    y1: 91.5002,
    x2: 242.3364,
    y2: 82.0692,
    id: "Stroke-377",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.6469,
    y1: 34.6858,
    x2: 303.7459,
    y2: 50.6608,
    id: "Stroke-379",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.786,
    y1: 99.1409,
    x2: 261.647,
    y2: 34.6859,
    id: "Stroke-381",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 169.0339,
    x2: 70.3356,
    y2: 176.6659,
    id: "Stroke-383",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6571,177.8865 C71.6501,177.8905 71.6431,177.8935 71.6361,177.8955 C71.6281,177.8985 71.6201,177.9005 71.6131,177.9025 C71.5971,177.9065 71.5811,177.9075 71.5651,177.9095 L71.5531,177.9095 L71.5481,177.9095 C71.5461,177.9095 71.5441,177.9105 71.5421,177.9105 C71.5331,177.9105 71.5261,177.9095 71.5171,177.9095 C71.5021,177.9085 71.4861,177.9075 71.4701,177.9045 C71.4391,177.8995 71.4071,177.8905 71.3781,177.8785 C71.3631,177.8725 71.3481,177.8655 71.3351,177.8585 C71.3271,177.8545 71.3211,177.8505 71.3141,177.8455 C71.3071,177.8415 71.3011,177.8365 71.2951,177.8315",
    id: "Stroke-385",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.3358,
    y1: 178.1394,
    x2: 90.4488,
    y2: 170.5074,
    id: "Stroke-387",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 169.821,
    x2: 70.3356,
    y2: 177.453,
    id: "Stroke-389",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.8705,
    y1: 261.9304,
    x2: 68.9975,
    y2: 246.3244,
    id: "Stroke-391",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.3358,
    y1: 245.8162,
    x2: 90.4488,
    y2: 238.1842,
    id: "Stroke-393",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.8705,
    y1: 263.6804,
    x2: 90.4485,
    y2: 239.9344,
    id: "Stroke-395",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.8861,
    y1: 90.5085,
    x2: 176.3501,
    y2: 122.2065,
    id: "Stroke-397",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.8724,
    y1: 158.3103,
    x2: 176.3504,
    y2: 190.0023,
    id: "Stroke-399",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.3358,
    y1: 201.7214,
    x2: 90.4488,
    y2: 194.0884,
    id: "Stroke-401",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 193.4021,
    x2: 70.3356,
    y2: 201.0351,
    id: "Stroke-403",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.5262,
    y1: 168.2986,
    x2: 109.5222,
    y2: 168.3016,
    id: "Stroke-405",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5331,168.3015 C109.8471,168.4305 110.1611,168.5595 110.4751,168.6895 C110.6321,168.7535 110.7891,168.8185 110.9461,168.8825 C110.9561,168.8865 110.9661,168.8905 110.9751,168.8945 C110.9851,168.8975 110.9941,168.9005 111.0041,168.9025 C111.0231,168.9055 111.0421,168.9065 111.0611,168.9055 C111.0791,168.9045 111.0971,168.9005 111.1141,168.8935 C111.1241,168.8885 111.1351,168.8825 111.1451,168.8765",
    id: "Stroke-407",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5008,166.0867 C110.6258,166.1377 110.7518,166.1897 110.8778,166.2407 C110.9068,166.2527 110.9358,166.2657 110.9638,166.2767 L110.9858,166.2857 C110.9878,166.2867 110.9898,166.2867 110.9918,166.2877 C110.9928,166.2887 110.9948,166.2897 110.9968,166.2897 C110.9988,166.2907 111.0008,166.2917 111.0018,166.2927 C111.0038,166.2927 111.0058,166.2937 111.0068,166.2947 C111.0108,166.2967 111.0138,166.2977 111.0178,166.2997 L111.0278,166.3057 C111.0348,166.3097 111.0408,166.3137 111.0478,166.3177 C111.0548,166.3227 111.0618,166.3267 111.0678,166.3327 C111.0708,166.3347 111.0748,166.3377 111.0778,166.3407 C111.0808,166.3437 111.0838,166.3457 111.0878,166.3497 C111.1008,166.3607 111.1138,166.3737 111.1258,166.3877 C111.1388,166.4007 111.1498,166.4157 111.1618,166.4317 C111.1648,166.4357 111.1678,166.4397 111.1698,166.4427 C111.1728,166.4477 111.1758,166.4517 111.1778,166.4557 C111.1838,166.4647 111.1888,166.4727 111.1938,166.4817 C111.1978,166.4887 111.2018,166.4967 111.2068,166.5047 C111.2098,166.5127 111.2138,166.5207 111.2178,166.5277 C111.2258,166.5437 111.2318,166.5607 111.2378,166.5767 L111.2428,166.5887 C111.2438,166.5917 111.2448,166.5937 111.2448,166.5957 C111.2448,166.5967 111.2458,166.5977 111.2458,166.5987 C111.2458,166.5997 111.2468,166.6007 111.2468,166.6017 C111.2498,166.6097 111.2518,166.6187 111.2548,166.6267 C111.2568,166.6357 111.2588,166.6437 111.2608,166.6517 C111.2618,166.6557 111.2628,166.6607 111.2638,166.6647 L111.2658,166.6707 C111.2658,166.6737 111.2658,166.6757 111.2668,166.6777 C111.2688,166.6867 111.2698,166.6937 111.2708,166.7027 C111.2718,166.7067 111.2718,166.7107 111.2728,166.7157 C111.2728,166.7197 111.2738,166.7237 111.2738,166.7287 C111.2748,166.7357 111.2758,166.7447 111.2768,166.7527 C111.2768,166.7567 111.2768,166.7607 111.2768,166.7647 L111.2768,166.7767 L111.2768,166.7887 C111.2768,166.7927 111.2768,166.7967 111.2768,166.8017 C111.2768,166.8097 111.2768,166.8167 111.2758,166.8257 C111.2758,166.8417 111.2758,166.8577 111.2748,166.8737 C111.2728,167.0107 111.2708,167.1467 111.2678,167.2817 C111.2628,167.5537 111.2578,167.8247 111.2528,168.0977 C111.2508,168.2327 111.2478,168.3687 111.2448,168.5047 C111.2448,168.5427 111.2438,168.5817 111.2428,168.6197 C111.2428,168.6247 111.2428,168.6297 111.2428,168.6347 L111.2428,168.6417 L111.2428,168.6487 C111.2428,168.6507 111.2418,168.6527 111.2418,168.6557 C111.2418,168.6577 111.2418,168.6607 111.2418,168.6627 C111.2408,168.6677 111.2408,168.6727 111.2398,168.6767 C111.2398,168.6817 111.2388,168.6867 111.2378,168.6907 C111.2378,168.6917 111.2378,168.6927 111.2378,168.6937 C111.2378,168.6947 111.2378,168.6957 111.2368,168.6967 C111.2368,168.6997 111.2368,168.7017 111.2358,168.7037 C111.2348,168.7127 111.2328,168.7217 111.2308,168.7307 C111.2268,168.7467 111.2218,168.7637 111.2148,168.7787 C111.2128,168.7827 111.2118,168.7857 111.2098,168.7897 C111.2088,168.7937 111.2068,168.7967 111.2058,168.8007 C111.2018,168.8077 111.1978,168.8147 111.1938,168.8207 C111.1898,168.8267 111.1858,168.8327 111.1818,168.8387 C111.1798,168.8417 111.1768,168.8447 111.1748,168.8477 C111.1728,168.8497 111.1698,168.8527 111.1678,168.8557 C111.1658,168.8577 111.1638,168.8597 111.1608,168.8617 C111.1588,168.8647 111.1558,168.8667 111.1528,168.8687 L111.1458,168.8747 C111.1428,168.8767 111.1408,168.8787 111.1378,168.8807",
    id: "Stroke-409",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.0428,
    y1: 163.8865,
    x2: 108.8348,
    y2: 161.7445,
    id: "Stroke-411",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1376,168.8806 C111.1396,168.8796 111.1426,168.8776 111.1446,168.8766",
    id: "Stroke-413",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.1527,162.2791 C108.1527,162.2891 108.1527,162.2981 108.1527,162.3061 C108.1527,162.3101 108.1517,162.3151 108.1517,162.3191 L108.1517,162.3231 L108.1517,162.3261 L108.1517,162.3331 C108.1517,162.3501 108.1507,162.3681 108.1507,162.3851 C108.1497,162.4211 108.1497,162.4561 108.1487,162.4911 C108.1477,162.5611 108.1457,162.6321 108.1447,162.7031 C108.1417,162.8431 108.1387,162.9841 108.1367,163.1261 C108.1317,163.4081 108.1267,163.6901 108.1207,163.9721 C108.1107,164.5361 108.0997,165.1001 108.0897,165.6641 C108.0787,166.2271 108.0687,166.7921 108.0577,167.3551 C108.0527,167.6371 108.0477,167.9201 108.0427,168.2011 C108.0397,168.3421 108.0367,168.4831 108.0347,168.6251 C108.0327,168.6951 108.0317,168.7651 108.0297,168.8371 C108.0297,168.8721 108.0287,168.9071 108.0277,168.9421 C108.0277,168.9601 108.0277,168.9771 108.0277,168.9951 L108.0277,169.0021 L108.0277,169.0051 L108.0277,169.0081 C108.0277,169.0121 108.0267,169.0171 108.0267,169.0211 L108.0267,169.0481",
    id: "Stroke-415",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3915,161.8123 C108.3795,161.8183 108.3675,161.8253 108.3565,161.8333 C108.3445,161.8403 108.3325,161.8493 108.3225,161.8593 C108.3085,161.8713 108.2965,161.8833 108.2845,161.8963 C108.2725,161.9103 108.2625,161.9233 108.2515,161.9393 C108.2415,161.9543 108.2325,161.9703 108.2235,161.9873 C108.2145,162.0023 108.2065,162.0203 108.2005,162.0393 C108.1855,162.0753 108.1745,162.1133 108.1665,162.1533 C108.1625,162.1733 108.1605,162.1943 108.1575,162.2153 C108.1555,162.2363 108.1535,162.2573 108.1525,162.2793",
    id: "Stroke-417",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5546,164.78 L114.5546,164.763 C114.5546,164.726 114.5526,164.69 114.5476,164.652 C114.5426,164.607 114.5336,164.561 114.5226,164.515 C114.5106,164.468 114.4946,164.42 114.4766,164.374 C114.4686,164.355 114.4606,164.336 114.4516,164.317 C114.4386,164.29 114.4256,164.263 114.4106,164.238 C114.3946,164.209 114.3766,164.181 114.3576,164.155 C114.3486,164.141 114.3386,164.129 114.3286,164.116 C114.3166,164.1 114.3046,164.086 114.2926,164.072 C114.2746,164.051 114.2556,164.032 114.2366,164.014 C114.2056,163.985 114.1726,163.959 114.1386,163.937 C114.1076,163.917 114.0756,163.899 114.0426,163.886",
    id: "Stroke-419",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4574,165.6863 C109.4624,165.6863 109.4674,165.6853 109.4734,165.6853 C109.4784,165.6843 109.4844,165.6843 109.4894,165.6853 C109.5004,165.6853 109.5124,165.6873 109.5234,165.6893 C109.5294,165.6903 109.5354,165.6923 109.5404,165.6933 L109.5494,165.6963 C109.5524,165.6973 109.5554,165.6983 109.5584,165.6993 C109.5614,165.7003 109.5634,165.7013 109.5664,165.7023 C109.5694,165.7033 109.5724,165.7053 109.5754,165.7063 C109.5814,165.7073 109.5874,165.7103 109.5934,165.7123 C109.6364,165.7303 109.6794,165.7483 109.7234,165.7663 C109.8094,165.8013 109.8954,165.8373 109.9824,165.8733 L110.5004,166.0863",
    id: "Stroke-421",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4574,165.6863 C109.4694,165.6843 109.4824,165.6843 109.4954,165.6853 C109.5124,165.6863 109.5304,165.6893 109.5474,165.6943 C109.5644,165.6993 109.5814,165.7073 109.5984,165.7133 L109.6994,165.7543 C109.9674,165.8663 110.2364,165.9763 110.5054,166.0863",
    id: "Stroke-423",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 288.8503,
    x2: 90.4486,
    y2: 99.6483,
    id: "Stroke-425",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.5477,
    y1: 115.6228,
    x2: 132.5477,
    y2: 304.8248,
    id: "Stroke-427",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.8851,
    y1: 115.1155,
    x2: 132.5481,
    y2: 115.6225,
    id: "Stroke-429",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.8851,
    y1: 304.3171,
    x2: 133.8851,
    y2: 115.1151,
    id: "Stroke-431",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.8851,
    y1: 115.1155,
    x2: 91.7861,
    y2: 99.1405,
    id: "Stroke-433",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 99.6482,
    x2: 132.5476,
    y2: 115.6232,
    id: "Stroke-435",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.35,
    y1: 174.8816,
    x2: 242.308,
    y2: 149.8536,
    id: "Stroke-437",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.5052,
    y1: 225.2195,
    x2: 176.5052,
    y2: 190.3085,
    id: "Stroke-439",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.3939,
    y1: 193.7673,
    x2: 176.5049,
    y2: 225.2193,
    id: "Stroke-441",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.9276,
    y1: 157.4636,
    x2: 27.8706,
    y2: 173.0426,
    id: "Stroke-443",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.5199,
    y1: 146.8313,
    x2: 68.9279,
    y2: 155.7133,
    id: "Stroke-445",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.9276,
    y1: 155.7136,
    x2: 27.8706,
    y2: 171.2926,
    id: "Stroke-447",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.8705,
    y1: 153.5286,
    x2: 45.5195,
    y2: 146.8316,
    id: "Stroke-449",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.8006,
    y1: 74.1389,
    x2: 130.4496,
    y2: 67.4419,
    id: "Stroke-451",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.8705,
    y1: 263.6804,
    x2: 27.8705,
    y2: 74.8684,
    id: "Stroke-453",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.3358,
    y1: 154.5583,
    x2: 90.4488,
    y2: 146.9263,
    id: "Stroke-455",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.4564,
    y1: 233.3416,
    x2: 217.4564,
    y2: 252.1386,
    id: "Stroke-457",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.1185,
    y1: 233.8494,
    x2: 216.1185,
    y2: 252.6464,
    id: "Stroke-459",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.9427,
    y1: 237.0476,
    x2: 242.3077,
    y2: 230.3566,
    id: "Stroke-461",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.9427,
    y1: 215.408,
    x2: 242.3077,
    y2: 208.716,
    id: "Stroke-463",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.3929,
    y1: 12.6716,
    x2: 27.8709,
    y2: 76.6186,
    id: "Stroke-465",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.3929,
    y1: 10.9216,
    x2: 27.8709,
    y2: 74.8686,
    id: "Stroke-467",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.9847,
    y1: 288.7224,
    x2: 174.9847,
    y2: 269.2854,
    id: "Stroke-469",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.2806,
    y1: 236.5408,
    x2: 261.2806,
    y2: 255.9768,
    id: "Stroke-471",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.9847,
    y1: 269.2859,
    x2: 175.0127,
    y2: 269.2749,
    id: "Stroke-473",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.35,
    y1: 268.7673,
    x2: 259.943,
    y2: 237.0473,
    id: "Stroke-475",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.5912,
    y1: 236.5349,
    x2: 176.3502,
    y2: 267.7419,
    id: "Stroke-477",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.4496,
    y1: 166.3728,
    x2: 45.4496,
    y2: 237.3888,
    id: "Stroke-479",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.9979,
    y1: 246.324,
    x2: 68.9979,
    y2: 61.013,
    id: "Stroke-481",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.3358,
    y1: 245.8162,
    x2: 70.3358,
    y2: 60.5052,
    id: "Stroke-483",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.0126,
    y1: 101.2595,
    x2: 175.0126,
    y2: 269.2755,
    id: "Stroke-485",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.35,
    y1: 268.7673,
    x2: 176.35,
    y2: 100.7513,
    id: "Stroke-487",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 173.5017,
    x2: 70.3356,
    y2: 181.1337,
    id: "Stroke-489",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 172.1062,
    x2: 70.3356,
    y2: 179.7382,
    id: "Stroke-491",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4437,240.8767 C90.4437,240.8987 90.4397,240.9217 90.4317,240.9427 C90.4277,240.9537 90.4227,240.9657 90.4177,240.9767 C90.4107,240.9877 90.4037,240.9987 90.3957,241.0097 C90.3867,241.0217 90.3777,241.0327 90.3677,241.0437 C90.3567,241.0547 90.3447,241.0657 90.3327,241.0757 C90.3197,241.0877 90.3057,241.0987 90.2917,241.1077 C90.2767,241.1197 90.2607,241.1297 90.2437,241.1407 C90.2217,241.1527 90.1997,241.1657 90.1767,241.1767 C90.1517,241.1887 90.1267,241.2007 90.1007,241.2117 C90.0727,241.2227 90.0447,241.2327 90.0167,241.2427 C89.9867,241.2537 89.9567,241.2637 89.9257,241.2717 C89.8717,241.2867 89.8167,241.3007 89.7617,241.3127 C89.7047,241.3237 89.6467,241.3337 89.5887,241.3417 C89.4747,241.3567 89.3597,241.3667 89.2447,241.3697 C89.1877,241.3717 89.1317,241.3727 89.0747,241.3707 C89.0167,241.3697 88.9577,241.3677 88.8997,241.3627 C88.8417,241.3587 88.7837,241.3537 88.7257,241.3467 C88.6697,241.3397 88.6137,241.3297 88.5577,241.3197 C88.5277,241.3137 88.4977,241.3077 88.4677,241.3007 C88.4387,241.2947 88.4097,241.2877 88.3807,241.2787 C88.3537,241.2727 88.3267,241.2647 88.2997,241.2557 C88.2757,241.2477 88.2497,241.2387 88.2247,241.2307 C88.2087,241.2237 88.1927,241.2177 88.1757,241.2107 C88.1607,241.2037 88.1457,241.1977 88.1307,241.1897 C88.1157,241.1847 88.1017,241.1767 88.0887,241.1697 C88.0747,241.1627 88.0617,241.1557 88.0487,241.1477 C88.0367,241.1417 88.0257,241.1347 88.0137,241.1267 C88.0027,241.1197 87.9917,241.1117 87.9817,241.1047 C87.9717,241.0977 87.9627,241.0897 87.9527,241.0817 C87.9437,241.0747 87.9357,241.0667 87.9277,241.0597",
    id: "Stroke-493",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.4481,
    y1: 262.1716,
    x2: 34.4481,
    y2: 261.8766,
    id: "Stroke-495",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.3246,
    y1: 262.7195,
    x2: 34.3246,
    y2: 262.3375,
    id: "Stroke-497",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4481,262.1716 C34.4461,262.1816 34.4421,262.1926 34.4381,262.2016 C34.4331,262.2126 34.4271,262.2236 34.4221,262.2336 C34.4151,262.2436 34.4071,262.2546 34.4001,262.2646 C34.3911,262.2756 34.3821,262.2856 34.3721,262.2956 C34.3611,262.3066 34.3491,262.3176 34.3381,262.3266 C34.3251,262.3376 34.3111,262.3486 34.2981,262.3586 C34.2831,262.3676 34.2671,262.3776 34.2521,262.3876 C34.2351,262.3976 34.2171,262.4066 34.1991,262.4166 C34.1761,262.4286 34.1511,262.4406 34.1261,262.4506 C34.1001,262.4616 34.0731,262.4726 34.0451,262.4826 C34.0161,262.4926 33.9871,262.5026 33.9571,262.5116 C33.9261,262.5206 33.8941,262.5286 33.8621,262.5366 C33.8051,262.5506 33.7471,262.5636 33.6891,262.5726 C33.6291,262.5826 33.5691,262.5916 33.5081,262.5986 C33.4481,262.6046 33.3871,262.6086 33.3271,262.6126 C33.2681,262.6156 33.2091,262.6166 33.1501,262.6166 L33.1051,262.6166 C33.0981,262.6166 33.0911,262.6166 33.0831,262.6156 L33.0611,262.6156 C33.0311,262.6146 33.0021,262.6136 32.9721,262.6116 C32.9121,262.6086 32.8511,262.6046 32.7911,262.5976 C32.7311,262.5916 32.6701,262.5826 32.6111,262.5726 C32.5521,262.5626 32.4941,262.5506 32.4371,262.5366 C32.4061,262.5286 32.3741,262.5206 32.3431,262.5106 C32.3131,262.5016 32.2831,262.4916 32.2551,262.4826 C32.2271,262.4726 32.2001,262.4616 32.1731,262.4496 C32.1481,262.4396 32.1241,262.4276 32.1001,262.4146 C32.0821,262.4056 32.0651,262.3976 32.0481,262.3866 C32.0321,262.3776 32.0171,262.3676 32.0021,262.3576 C31.9891,262.3476 31.9751,262.3366 31.9631,262.3266 C31.9511,262.3166 31.9391,262.3066 31.9281,262.2956 C31.9191,262.2846 31.9091,262.2746 31.9011,262.2636 C31.8931,262.2536 31.8851,262.2426 31.8791,262.2326 C31.8731,262.2226 31.8671,262.2116 31.8631,262.2006 C31.8591,262.1906 31.8551,262.1796 31.8521,262.1696",
    id: "Stroke-499",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1229,168.8611 C111.1229,168.8601 111.1229,168.8601 111.1229,168.8601 C111.1249,168.8591 111.1269,168.8581 111.1279,168.8571",
    id: "Stroke-501",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1297,166.4255 C111.1407,166.4395 111.1507,166.4535 111.1607,166.4685 C111.1757,166.4905 111.1887,166.5145 111.1997,166.5395 C111.2117,166.5645 111.2217,166.5905 111.2287,166.6165 C111.2367,166.6435 111.2427,166.6695 111.2467,166.6965 C111.2497,166.7235 111.2517,166.7485 111.2507,166.7745 C111.2507,166.7865 111.2507,166.7995 111.2507,166.8125 C111.2497,166.8235 111.2497,166.8365 111.2497,166.8495 C111.2457,167.0495 111.2417,167.2495 111.2377,167.4495 C111.2347,167.6505 111.2307,167.8515 111.2277,168.0515 C111.2257,168.1515 111.2237,168.2515 111.2217,168.3515 C111.2207,168.4025 111.2197,168.4515 111.2187,168.5015 C111.2177,168.5275 111.2177,168.5515 111.2167,168.5765 C111.2167,168.5895 111.2167,168.6025 111.2167,168.6145 C111.2167,168.6265 111.2167,168.6395 111.2157,168.6525 C111.2147,168.6725 111.2127,168.6935 111.2087,168.7115",
    id: "Stroke-503",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2084,168.7117 C111.2084,168.7157 111.2074,168.7197 111.2064,168.7227 C111.2014,168.7437 111.1944,168.7657 111.1854,168.7837 C111.1754,168.8027 111.1654,168.8187 111.1524,168.8337 C111.1424,168.8457 111.1304,168.8557 111.1184,168.8637",
    id: "Stroke-505",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.9847,166.3386 C111.0017,166.3466 111.0187,166.3576 111.0347,166.3686 C111.0507,166.3806 111.0667,166.3956 111.0817,166.4096 C111.0967,166.4256 111.1117,166.4426 111.1247,166.4616 C111.1377,166.4796 111.1507,166.4996 111.1617,166.5206 C111.1727,166.5406 111.1827,166.5626 111.1917,166.5846 C111.1997,166.6076 111.2067,166.6296 111.2127,166.6526 C111.2127,166.6536 111.2137,166.6546 111.2137,166.6556",
    id: "Stroke-507",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.9178,168.8679 C110.7948,168.8169 110.6768,168.7689 110.5598,168.7209 C110.4418,168.6729 110.3258,168.6249 110.2098,168.5769 C110.0938,168.5289 109.9778,168.4809 109.8598,168.4329 C109.7428,168.3849 109.6248,168.3359 109.5018,168.2859",
    id: "Stroke-509",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.0008,166.322 C111.0108,166.327 111.0208,166.332 111.0308,166.338 C111.0358,166.341 111.0408,166.344 111.0448,166.347 C111.0498,166.35 111.0548,166.354 111.0598,166.358 L111.0748,166.37 C111.0788,166.374 111.0838,166.378 111.0878,166.382 C111.0928,166.386 111.0978,166.39 111.1028,166.395 L111.1158,166.41 C111.1198,166.415 111.1248,166.42 111.1278,166.425 C111.1328,166.429 111.1368,166.435 111.1408,166.44 C111.1488,166.451 111.1568,166.462 111.1648,166.473 C111.1678,166.479 111.1718,166.485 111.1748,166.492 L111.1858,166.509 C111.1888,166.515 111.1918,166.522 111.1948,166.528 C111.1978,166.535 111.2008,166.541 111.2038,166.548 C111.2068,166.554 111.2088,166.56 111.2118,166.567 C111.2148,166.574 111.2168,166.581 111.2198,166.588 C111.2208,166.591 111.2218,166.593 111.2228,166.597 C111.2238,166.6 111.2248,166.604 111.2268,166.607 C111.2268,166.609 111.2278,166.611 111.2278,166.612 C111.2278,166.613 111.2288,166.614 111.2288,166.615 C111.2288,166.616 111.2288,166.617 111.2298,166.618 C111.2298,166.621 111.2308,166.625 111.2318,166.628 C111.2338,166.634 111.2358,166.641 111.2368,166.648 C111.2378,166.65 111.2378,166.651 111.2388,166.653 C111.2388,166.655 111.2388,166.657 111.2398,166.658 C111.2398,166.662 111.2408,166.665 111.2418,166.669 C111.2428,166.676 111.2438,166.682 111.2448,166.688 C111.2458,166.692 111.2458,166.695 111.2468,166.699 C111.2478,166.703 111.2478,166.706 111.2478,166.71 C111.2488,166.717 111.2498,166.723 111.2498,166.729 C111.2508,166.736 111.2508,166.743 111.2508,166.75 L111.2508,166.759 L111.2508,166.769 L111.2508,166.774",
    id: "Stroke-511",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2084,168.7117 C111.2074,168.7177 111.2064,168.7237 111.2054,168.7297 C111.2034,168.7347 111.2024,168.7397 111.2004,168.7457 C111.1964,168.7567 111.1924,168.7677 111.1884,168.7767 L111.1854,168.7837 C111.1844,168.7867 111.1824,168.7887 111.1814,168.7907 C111.1784,168.7957 111.1764,168.8007 111.1734,168.8047 C111.1724,168.8077 111.1704,168.8097 111.1694,168.8117 L111.1654,168.8167 C111.1624,168.8217 111.1594,168.8257 111.1564,168.8287 C111.1524,168.8327 111.1494,168.8367 111.1464,168.8407 C111.1434,168.8437 111.1394,168.8477 111.1354,168.8507 C111.1344,168.8527 111.1324,168.8537 111.1304,168.8557 C111.1284,168.8567 111.1264,168.8577 111.1254,168.8587 C111.1224,168.8607 111.1204,168.8627 111.1184,168.8637",
    id: "Stroke-513",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.9178,168.8679 L110.9248,168.8709 C110.9258,168.8719 110.9278,168.8719 110.9288,168.8719 C110.9288,168.8729 110.9298,168.8729 110.9308,168.8729 C110.9358,168.8749 110.9398,168.8769 110.9448,168.8779 C110.9488,168.8789 110.9538,168.8799 110.9588,168.8819 C110.9628,168.8829 110.9668,168.8829 110.9718,168.8839 C110.9758,168.8849 110.9798,168.8849 110.9838,168.8859 C110.9878,168.8859 110.9928,168.8869 110.9968,168.8869 C111.0048,168.8869 111.0138,168.8869 111.0228,168.8859 C111.0248,168.8849 111.0268,168.8849 111.0288,168.8849 C111.0308,168.8849 111.0328,168.8839 111.0348,168.8839 C111.0368,168.8829 111.0388,168.8829 111.0418,168.8829 C111.0428,168.8819 111.0448,168.8819 111.0468,168.8809 C111.0548,168.8789 111.0628,168.8759 111.0698,168.8729 C111.0728,168.8719 111.0758,168.8699 111.0788,168.8689",
    id: "Stroke-515",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.0785,168.8689 C111.0795,168.8679 111.0805,168.8679 111.0805,168.8669 C111.0845,168.8649 111.0885,168.8629 111.0925,168.8609 C111.0935,168.8599 111.0955,168.8589 111.0975,168.8579 C111.0995,168.8559 111.1005,168.8549 111.1025,168.8539 C111.1055,168.8509 111.1085,168.8479 111.1125,168.8469 C111.1135,168.8449 111.1155,168.8439 111.1175,168.8419 C111.1185,168.8409 111.1205,168.8389 111.1215,168.8379 C111.1245,168.8349 111.1275,168.8309 111.1305,168.8279 C111.1335,168.8249 111.1355,168.8209 111.1385,168.8169 C111.1405,168.8139 111.1435,168.8099 111.1465,168.8069 C111.1475,168.8049 111.1485,168.8029 111.1495,168.8019 C111.1515,168.7999 111.1525,168.7969 111.1535,168.7949 C111.1545,168.7929 111.1555,168.7909 111.1575,168.7889 L111.1605,168.7829 C111.1645,168.7739 111.1685,168.7649 111.1715,168.7559 C111.1755,168.7469 111.1785,168.7369 111.1805,168.7269 C111.1825,168.7229 111.1835,168.7179 111.1845,168.7119 C111.1855,168.7069 111.1865,168.7019 111.1875,168.6959 C111.1885,168.6909 111.1885,168.6849 111.1895,168.6809 C111.1905,168.6779 111.1905,168.6749 111.1905,168.6719 C111.1905,168.6689 111.1915,168.6659 111.1915,168.6629 C111.1925,168.6579 111.1925,168.6519 111.1925,168.6459 C111.1925,168.6429 111.1925,168.6409 111.1925,168.6389 L111.1925,168.6369 L111.1925,168.6339 C111.1935,168.6329 111.1935,168.6309 111.1935,168.6299",
    id: "Stroke-517",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2274,166.7888 L111.2274,166.7808 L111.2274,166.7788 L111.2274,166.7768 L111.2274,166.7728 C111.2274,166.7678 111.2274,166.7618 111.2274,166.7558 L111.2274,166.7478 C111.2264,166.7448 111.2264,166.7418 111.2264,166.7388 C111.2264,166.7338 111.2254,166.7278 111.2254,166.7228 L111.2234,166.7138 C111.2234,166.7108 111.2234,166.7078 111.2224,166.7048 C111.2214,166.6998 111.2214,166.6928 111.2204,166.6878 C111.2194,166.6848 111.2184,166.6828 111.2184,166.6798 L111.2164,166.6708 C111.2154,166.6648 111.2144,166.6588 111.2124,166.6528 C111.2114,166.6478 111.2094,166.6428 111.2084,166.6368 C111.2064,166.6308 111.2054,166.6248 111.2034,166.6188 C111.2014,166.6138 111.1994,166.6078 111.1974,166.6018 C111.1954,166.5968 111.1934,166.5908 111.1914,166.5858 C111.1874,166.5738 111.1834,166.5628 111.1774,166.5528 C111.1754,166.5468 111.1724,166.5418 111.1704,166.5368 L111.1674,166.5308",
    id: "Stroke-519",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4525,165.7126 C109.4395,165.7136 109.4275,165.7166 109.4145,165.7216 C109.4085,165.7236 109.4025,165.7266 109.3965,165.7296 C109.3915,165.7326 109.3855,165.7346 109.3805,165.7386 C109.3785,165.7396 109.3775,165.7406 109.3765,165.7416 C109.3745,165.7416 109.3735,165.7426 109.3715,165.7436 C109.3695,165.7456 109.3675,165.7476 109.3645,165.7506 C109.3585,165.7546 109.3535,165.7596 109.3495,165.7636 C109.3445,165.7686 109.3405,165.7736 109.3355,165.7786 C109.3345,165.7796 109.3335,165.7806 109.3325,165.7826 C109.3315,165.7836 109.3305,165.7856 109.3295,165.7866 L109.3235,165.7956 C109.3215,165.7986 109.3195,165.8016 109.3175,165.8046 C109.3155,165.8076 109.3145,165.8106 109.3125,165.8136 L109.3025,165.8326 C109.3015,165.8366 109.2995,165.8396 109.2985,165.8436 C109.2965,165.8476 109.2955,165.8506 109.2945,165.8546 C109.2925,165.8586 109.2915,165.8606 109.2905,165.8646 C109.2895,165.8686 109.2885,165.8726 109.2865,165.8756 C109.2855,165.8836 109.2835,165.8916 109.2815,165.8996 C109.2795,165.9066 109.2785,165.9146 109.2775,165.9226 C109.2755,165.9316 109.2745,165.9396 109.2745,165.9476 C109.2735,165.9516 109.2735,165.9556 109.2735,165.9606 C109.2735,165.9626 109.2735,165.9646 109.2725,165.9666 L109.2725,165.9736 C109.2725,165.9776 109.2725,165.9806 109.2725,165.9836 L109.2725,165.9866 L109.2725,165.9896 L109.2725,165.9946 C109.2725,166.0016 109.2725,166.0096 109.2715,166.0166 C109.2715,166.0306 109.2715,166.0456 109.2705,166.0596 C109.2705,166.0886 109.2695,166.1166 109.2695,166.1466 C109.2685,166.2036 109.2675,166.2616 109.2655,166.3186 C109.2625,166.5486 109.2575,166.7786 109.2535,167.0096 C109.2495,167.2396 109.2445,167.4706 109.2405,167.7006 C109.2405,167.7286 109.2395,167.7566 109.2395,167.7836 C109.2385,167.7906 109.2385,167.7976 109.2385,167.8046 C109.2385,167.8096 109.2385,167.8206 109.2385,167.8256 L109.2385,167.8356 L109.2385,167.8416 L109.2385,167.8466 C109.2385,167.8536 109.2385,167.8606 109.2395,167.8676 C109.2395,167.8716 109.2395,167.8746 109.2395,167.8786 C109.2405,167.8826 109.2405,167.8856 109.2415,167.8896 C109.2415,167.8976 109.2425,167.9036 109.2435,167.9106 C109.2445,167.9146 109.2445,167.9186 109.2455,167.9216 C109.2455,167.9256 109.2465,167.9296 109.2475,167.9326 C109.2485,167.9406 109.2505,167.9466 109.2515,167.9546 C109.2525,167.9586 109.2535,167.9616 109.2545,167.9656 C109.2555,167.9696 109.2565,167.9736 109.2575,167.9766 C109.2595,167.9836 109.2615,167.9906 109.2645,167.9976 C109.2655,168.0016 109.2655,168.0056 109.2675,168.0086 C109.2685,168.0126 109.2695,168.0166 109.2715,168.0196 C109.2735,168.0266 109.2765,168.0336 109.2795,168.0406 C109.2825,168.0476 109.2855,168.0556 109.2885,168.0626 C109.2905,168.0666 109.2915,168.0696 109.2935,168.0726 C109.2945,168.0746 109.2955,168.0766 109.2965,168.0776 C109.2965,168.0796 109.2965,168.0796 109.2975,168.0806 L109.2985,168.0836 C109.3025,168.0906 109.3065,168.0976 109.3095,168.1046 C109.3115,168.1086 109.3135,168.1106 109.3155,168.1136 C109.3165,168.1146 109.3165,168.1156 109.3165,168.1166 C109.3175,168.1176 109.3175,168.1186 109.3185,168.1196 C109.3195,168.1206 109.3205,168.1226 109.3215,168.1246 C109.3255,168.1306 109.3295,168.1376 109.3345,168.1436 C109.3365,168.1476 109.3385,168.1506 109.3405,168.1526 C109.3425,168.1556 109.3455,168.1586 109.3475,168.1626 C109.3565,168.1746 109.3655,168.1856 109.3755,168.1966 C109.3775,168.1986 109.3805,168.2016 109.3835,168.2046 C109.3855,168.2076 109.3885,168.2096 109.3905,168.2126 C109.3955,168.2176 109.4005,168.2226 109.4065,168.2276 C109.4155,168.2356 109.4265,168.2446 109.4375,168.2536 C109.4385,168.2546 109.4405,168.2556 109.4415,168.2566 C109.4435,168.2576 109.4445,168.2586 109.4455,168.2596 C109.4485,168.2606 109.4515,168.2626 109.4535,168.2646 C109.4595,168.2686 109.4655,168.2716 109.4715,168.2746 C109.4765,168.2776 109.4825,168.2806 109.4875,168.2836 C109.4895,168.2836 109.4905,168.2846 109.4925,168.2846 C109.4935,168.2856 109.4945,168.2866 109.4965,168.2866 C109.4985,168.2886 109.5015,168.2896 109.5045,168.2906",
    id: "Stroke-521",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4525,165.7126 C109.4595,165.7116 109.4665,165.7106 109.4735,165.7106 C109.4915,165.7106 109.5105,165.7126 109.5295,165.7186 C109.5385,165.7216 109.5485,165.7246 109.5585,165.7286 C109.5675,165.7336 109.5775,165.7366 109.5875,165.7406 C109.7435,165.8046 109.8995,165.8686 110.0555,165.9326 C110.2105,165.9966 110.3665,166.0616 110.5225,166.1246 C110.5995,166.1566 110.6785,166.1896 110.7555,166.2216 C110.7945,166.2366 110.8335,166.2526 110.8725,166.2696 C110.8915,166.2766 110.9115,166.2846 110.9315,166.2936 C110.9405,166.2966 110.9505,166.3016 110.9605,166.3056 L110.9895,166.3166",
    id: "Stroke-523",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5047,168.2908 C109.5127,168.2948 109.5217,168.2978 109.5297,168.3018 C109.5337,168.3038 109.5387,168.3048 109.5427,168.3068 C109.5467,168.3088 109.5507,168.3108 109.5547,168.3118 C109.5717,168.3178 109.5887,168.3248 109.6057,168.3318 C109.6387,168.3458 109.6717,168.3598 109.7057,168.3738 C109.7727,168.4008 109.8397,168.4288 109.9067,168.4558 C110.0407,168.5118 110.1737,168.5658 110.3087,168.6208 C110.4417,168.6768 110.5757,168.7308 110.7097,168.7868 C110.7767,168.8138 110.8437,168.8418 110.9107,168.8688 C110.9127,168.8698 110.9157,168.8708 110.9177,168.8718 C110.9197,168.8728 110.9217,168.8738 110.9237,168.8748 C110.9277,168.8768 110.9327,168.8778 110.9377,168.8798 C110.9467,168.8828 110.9557,168.8868 110.9647,168.8888 C110.9667,168.8888 110.9697,168.8898 110.9717,168.8898 C110.9737,168.8908 110.9767,168.8908 110.9787,168.8918 C110.9837,168.8928 110.9877,168.8928 110.9927,168.8938 C111.0017,168.8948 111.0097,168.8948 111.0197,168.8948 L111.0257,168.8948 L111.0327,168.8948 C111.0367,168.8938 111.0417,168.8938 111.0457,168.8928 C111.0477,168.8928 111.0497,168.8918 111.0517,168.8918 C111.0527,168.8918 111.0537,168.8918 111.0547,168.8908 L111.0587,168.8908 C111.0627,168.8898 111.0667,168.8878 111.0707,168.8868 C111.0797,168.8848 111.0877,168.8808 111.0957,168.8768 C111.0987,168.8748 111.1027,168.8728 111.1067,168.8708 C111.1107,168.8688 111.1137,168.8668 111.1177,168.8638",
    id: "Stroke-525",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1171,168.865 C111.1161,168.866 111.1151,168.867 111.1131,168.867 C111.1121,168.868 111.1121,168.868 111.1111,168.869",
    id: "Stroke-527",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.8578,
    y1: 217.2517,
    x2: 176.3498,
    y2: 248.9397,
    id: "Stroke-529",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.8578,
    y1: 215.4841,
    x2: 176.3498,
    y2: 247.1711,
    id: "Stroke-531",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.3929,
    y1: 70.6077,
    x2: 70.3359,
    y2: 86.1867,
    id: "Stroke-533",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.3929,
    y1: 68.8577,
    x2: 111.3929,
    y2: 70.6077,
    id: "Stroke-535",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9847,
    y1: 59.9753,
    x2: 111.3927,
    y2: 68.8573,
    id: "Stroke-537",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.3929,
    y1: 68.8577,
    x2: 70.3359,
    y2: 84.4367,
    id: "Stroke-539",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.3358,
    y1: 66.6721,
    x2: 87.9848,
    y2: 59.9751,
    id: "Stroke-541",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.8578,
    y1: 54.4929,
    x2: 112.8008,
    y2: 70.0729,
    id: "Stroke-543",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.8578,
    y1: 52.7429,
    x2: 112.8008,
    y2: 68.3229,
    id: "Stroke-545",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.8006,
    y1: 50.5579,
    x2: 130.4496,
    y2: 43.8609,
    id: "Stroke-547",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 149.9207,
    x2: 70.3356,
    y2: 157.5527,
    id: "Stroke-549",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 148.5256,
    x2: 70.3356,
    y2: 156.1566,
    id: "Stroke-551",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.308,
    y1: 208.7927,
    x2: 176.35,
    y2: 233.8197,
    id: "Stroke-553",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 197.0828,
    x2: 70.3356,
    y2: 204.7148,
    id: "Stroke-555",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 195.6873,
    x2: 70.3356,
    y2: 203.3203,
    id: "Stroke-557",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 102.136,
    x2: 70.3356,
    y2: 109.768,
    id: "Stroke-559",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9847,
    y1: 83.5564,
    x2: 110.4207,
    y2: 92.0694,
    id: "Stroke-561",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 100.386,
    x2: 70.3356,
    y2: 108.018,
    id: "Stroke-563",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.3358,
    y1: 90.2532,
    x2: 87.9848,
    y2: 83.5562,
    id: "Stroke-565",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 145.4524,
    x2: 70.3356,
    y2: 153.0844,
    id: "Stroke-567",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 146.2405,
    x2: 70.3356,
    y2: 153.8715,
    id: "Stroke-569",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 125.7175,
    x2: 70.3356,
    y2: 133.3495,
    id: "Stroke-571",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9847,
    y1: 107.1375,
    x2: 90.4487,
    y2: 108.0725,
    id: "Stroke-573",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 123.967,
    x2: 70.3356,
    y2: 131.599,
    id: "Stroke-575",
    stroke: "#000000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.3358,
    y1: 113.8347,
    x2: 87.9848,
    y2: 107.1377,
    id: "Stroke-577",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4486,
    y1: 192.615,
    x2: 70.3356,
    y2: 200.247,
    id: "Stroke-579",
    stroke: "#2E3030",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketCloset);
export default __webpack_public_path__ + "static/media/pocket_closet.1bd2c6b3485447c94d46180d3667a192.svg";
export { ForwardRef as ReactComponent };